import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const GOLD_INK = '#8F650F';
const GOLD = '#D89232';
const ESPRESSO = '#2B2118';

const SPLIT = [
  { label: 'Pflegefachwissen', hours: 100 },
  { label: 'Case Management', hours: 170 },
  { label: 'Recht', hours: 130 },
];
const MAX = 170;

export const CourseUeBreakdown = ({ courseId }) => {
  if (courseId !== 'course-pflegeberater') return null;
  return (
    <div className="mb-10 bg-cream-100 shadow-soft" style={{ border: '1px solid rgba(216,146,50,0.4)', padding: 8 }} data-testid="ue-breakdown">
      <div className="px-6 md:px-8 py-6" style={{ border: '1px solid rgba(216,146,50,0.4)' }}>
        <p className="font-mono text-[10px] uppercase font-semibold" style={{ letterSpacing: '0.24em', color: GOLD_INK }}>
          Offizieller Rahmen · GKV-Empfehlungen nach §7a Abs. 3 SGB XI
        </p>
        <p className="font-display text-[20px] mt-2" style={{ color: ESPRESSO }}>
          Die vorgeschriebene Stundenaufteilung — <span className="italic" style={{ color: '#E07A5F' }}>von diesem Kurs erfüllt</span>.
        </p>

        <div className="mt-5 space-y-4">
          {SPLIT.map((s) => (
            <div key={s.label} data-testid={`ue-split-${s.label.toLowerCase().replace(/\s/g, '-')}`}>
              <div className="flex items-baseline justify-between mb-1.5">
                <span className="font-mono text-[10.5px] uppercase font-semibold" style={{ letterSpacing: '0.18em', color: '#5E544D' }}>
                  {s.label}
                </span>
                <span className="font-display text-[15px]" style={{ color: ESPRESSO }}>
                  mind. {s.hours} Std.
                </span>
              </div>
              <div className="h-[5px] w-full" style={{ backgroundColor: '#E0D6CA' }}>
                <div className="h-full" style={{ width: `${(s.hours / MAX) * 100}%`, backgroundColor: GOLD }} />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 pt-4 flex flex-wrap items-center gap-x-6 gap-y-2" style={{ borderTop: '1px solid rgba(216,146,50,0.35)' }}>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4" style={{ color: GOLD_INK }} aria-hidden />
            <span className="text-[13.5px] text-sand-700">Mind. 400 Std. gefordert — dieser Kurs: <strong style={{ color: ESPRESSO }}>480 UE</strong></span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle2 className="w-4 h-4" style={{ color: GOLD_INK }} aria-hidden />
            <span className="text-[13.5px] text-sand-700">Zzgl. <strong style={{ color: ESPRESSO }}>9 Tage Praktikum</strong> (selbst zu organisieren — den Praktikumsnachweis stellen wir bereit)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseUeBreakdown;
